import * as z from "zod";

export const getTextConciergeFleetAnalytics = {
  name: "getTextConciergeFleetAnalytics" as const,
  input: z.object({ start: z.date(), end: z.date() }),

  output: z.object({
    // Fleet-level headline counts.
    brandCount: z.number(),
    recoverEnabledCount: z.number(),
    iPhonesAvailable: z.number(),
    messagesPerDay: z.number(),
    // Pooled analytics across every enabled brand (same shape as the
    // per-merchant dashboard, summed).
    outboundMessages: z.number(),
    uniqueRecipients: z.number(),
    customerReplies: z.number(),
    conversationsWithReply: z.number(),
    escalatedConversations: z.number(),
    medianRepliesPerReplier: z.number(),
    maxRepliesPerReplier: z.number(),
    timeSeries: z.array(
      z.object({ date: z.string(), outbound: z.number(), replies: z.number() }),
    ),
  }),
};
